import cross from "../../assets/icons/cross-svgrepo-com.svg";
import reload from "../../assets/icons/reload-svgrepo-com.svg";
import DetailCard from "./DetailCard";

interface Props {
  onClose: () => void;
  totalhours: number;
  billablehours: number;
  unbilliblehours: number;
  plannedhours: number;
  unpayed: number;
  payed: number;
  afgeboekt: number;
  totalcosts: number;
  hours: number;
  spending: number;
  rides: number;
  totalkm: number;
  budget: string;
}

const ProjectDetail = ({
  onClose,
  totalhours,
  budget,
  billablehours,
  unbilliblehours,
  plannedhours,
  unpayed,
  payed,
  afgeboekt,
  totalcosts,
  hours,
  spending,
  rides,
  totalkm,
}: Props) => {
  return (
    <div className="fixed top-0 mt-20 mb-2 ml-auto right-0 bg-white rounded-lg h-[87%] w-[40%] z-50 border">
      <div className="flex flex-row">
        {/* <img
          src={reload}
          alt="Cross for closing details of the selected project"
          className="w-10 ml-auto cursor-pointer transform scale-75 0.3s ease-in-out hover:scale-100"
          onClick={onClose}
        /> */}
        <img
          src={cross}
          alt="Cross for closing details of the selected project"
          className="w-10 ml-auto cursor-pointer transform 0.3s ease-in-out hover:scale-125"
          onClick={onClose}
        />
      </div>

      <div className="h-[90%] flex flex-row flex-wrap justify-evenly">
        <DetailCard
          Titel="Totaal aantal uur"
          total={`${totalhours} (u)`}
          extra1="Facturabel"
          extra1amount={`${billablehours} (u)`}
          extra2="Niet facturabel"
          extra2amount={`${unbilliblehours} (u)`}
          extra3="Gepland (vanaf vandaag)"
          extra3amount={`${plannedhours} (u)`}
        />
        <DetailCard
          Titel="Ongefactureerd"
          total={`€${unpayed}`}
          extra1="Gefactureerd"
          extra1amount={`€${payed}`}
          extra2="Afgeboekt"
          extra2amount={`€${afgeboekt}`}
        />
        <DetailCard
          Titel="Kosten"
          total={`€${totalcosts}`}
          extra1="Uren"
          extra1amount={`€${hours}`}
          extra2="Uitgaven"
          extra2amount={`€${spending}`}
          extra3="Ritten"
          extra3amount={`€${rides}`}
        />
        <DetailCard Titel="Totaal aantal kilometers" total={`${totalkm} KM`} />
        <DetailCard Titel="Budget" total={budget} />
      </div>

      {/* <div className="flex justify-evenly">
        
        <div>
          <b className="text-gray-600 text-lg">Budget</b>
          <p className="h-16 text-center">€{budget}</p>
        </div>
        <div>
          <b className="text-gray-600 text-lg">Uitgaven</b>
          <p className="h-16 text-center">€{spent}</p>
        </div>
        <div>
          <b className="text-gray-600 text-lg">Percentage gebruikt</b>
          <p className="h-16 text-center">%{percentageused}</p>
        </div>
      </div> */}
      {/* <div className="flex justify-evenly">
        <div>
          <b className="text-gray-600 text-lg">km / € kmprice</b>
          <p className="h-16 text-center">
            {km} / €{kmprice}
          </p>
        </div>
        <div>
          <b className="text-gray-600 text-lg">Kosten </b>
          <p className="h-16 text-center">€{costs}</p>
        </div>
      </div> */}
      {/* <div className="flex justify-evenly">
        <div>
          <b className="text-gray-600 text-lg">Status</b>
          <p className="h-16 text-center">{status}</p>
        </div>
        <div>
          <b className="text-gray-600 text-lg">Factuur status</b>
          <p className="h-16 text-center">{billingstatus}</p>
        </div>
      </div> */}
      <p>(Hier wordt aan gewerkt)</p>
    </div>
  );
};

export default ProjectDetail;
